export const UPDATE_ABILITY_COOLDOWN = "UPDATE_ABILITY_COOLDOWN";
export const UPDATE_PLAYER_NAME = "UPDATE_PLAYER_NAME";
